// When a café was created / a PC was registered, for display.
//
// Neither date was recorded before 2026-09-29. Rows that existed before then
// carry a best guess worked out from other records, flagged `approx` by the
// backend (see backend/app/db/registration_dates.py). Those must never read as
// exact, so they get a "~" (with APPROX_HINT on hover where shown; it was
// "~date (approx.)" until 2026-10-16, which made list columns wrap). No date at all means there was
// nothing to guess from — say so rather than showing a blank.
//
// Shown in café-local time (every café is IST), so a café created late on the
// 3rd doesn't show as the 4th to someone reading this abroad.

const FORMAT = { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Kolkata' };

// { short: true } leaves the year off a date in the current year ("~27 Jul").
export function formatRegDate(iso, approx, { short = false } = {}) {
    if (!iso) return 'Not recorded';
    // The backend sends offset-aware ISO; tag a bare one as UTC like every
    // other timestamp in this app, rather than letting the browser read it as local.
    const d = new Date(/[zZ]|[+-]\d{2}:?\d{2}$/.test(iso) ? iso : `${iso}Z`);
    if (Number.isNaN(d.getTime())) return 'Not recorded';
    const sameYear = d.getFullYear() === new Date().getFullYear();
    const text = d.toLocaleDateString('en-IN', short && sameYear ? { day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata' } : FORMAT);
    return approx ? `~${text}` : text;
}

export const APPROX_HINT = 'Best guess: this was added before the platform recorded these dates.';

// A PC's uninstall / reinstall history as one short line, or null when there
// is none. `uninstalled_at` is only set while the PC is uninstalled and has
// not come back, so it wins: that is the PC's state right now. A reinstalled
// PC keeps its ORIGINAL registered date (it re-registers onto the same
// record), which is why this line exists at all.
export function formatPcHistory(pc) {
    if (pc.uninstalled_at) return `Uninstalled ${formatRegDate(pc.uninstalled_at)}`;
    const n = pc.reinstall_count || 0;
    if (!n) return null;
    const when = pc.last_reinstalled_at ? ` ${formatRegDate(pc.last_reinstalled_at)}` : '';
    return `Reinstalled${when} · ${n} time${n === 1 ? '' : 's'}`;
}
